<template>
  <span class="account-selector-name">
    <img
      v-if="service === 'mytarget'"
      src="@/assets/icons/icon-mytarget-logo.svg"
      alt="platform-logo"
    />
    <img v-if="service === 'avito'" src="@/assets/icons/icon-avito.svg" alt="platform-logo" />
    <img
      v-if="service === 'vkontakte'"
      src="@/assets/icons/icon-vkontacte.svg"
      alt="platform-logo"
    />
    <img v-if="service === 'vkads'" src="@/assets/icons/icon-vkreklama.svg" alt="platform-logo" />
    <img v-if="service === 'facebook'" src="@/assets/icons/icon-meta.svg" alt="platform-logo" />
    <img
      v-if="service === 'yandex'"
      src="@/assets/icons/yandex-direct-icon.svg"
      alt="platform-logo"
    />
    <img v-if="service === 'google'" src="@/assets/icons/icon-google.svg" alt="platform-logo" />
    <img v-if="service === 'tiktok'" src="@/assets/icons/icon-tiktok.svg" alt="platform-logo" />
    <img v-if="service === 'telegram'" src="@/assets/icons/icon-telegram.svg" alt="platform-logo" />
    <img
      v-if="service === 'promopages'"
      src="@/assets/icons/icon-promo-page.jpeg"
      alt="platform-logo"
    />
    <img
      v-if="service === 'vkadblogger'"
      src="@/assets/icons/icon-vkadblogger.svg"
      alt="platform-logo"
    />
    <img
      v-if="service === 'yandexbusiness'"
      src="@/assets/icons/icon-yandex-business.png"
      alt="platform-logo"
    />
    <img v-if="service === 'rbk'" src="@/assets/icons/icon-rbk.png" alt="platform-logo" />
    <img v-if="service === 'roxot'" src="@/assets/icons/icon-roxot.jpeg" alt="platform-logo" />
    <img
      v-if="service === 'onetarget'"
      src="@/assets/icons/icon-onetarget.png"
      alt="platform-logo"
    />
    <img v-if="service === 'soloway'" src="@/assets/icons/icon-soloway.svg" alt="platform-logo" />
    <img v-if="service === 'hybrid'" src="@/assets/icons/icon-hybrid.png" alt="platform-logo" />
    <img
      v-if="service === 'mediaplatform'"
      src="@/assets/icons/icon-media.png"
      alt="platform-logo"
    />
    <img
      v-if="service === 'mts_sms' || service === 'mts_dsp'"
      src="@/assets/icons/icon-mts.svg"
      alt="platform-logo"
    />
    <img v-if="service === 'rutube'" src="@/assets/icons/icon-rutube.png" alt="platform-logo" />
    <img v-if="service === 'ivi'" src="@/assets/icons/icon-ivi.svg" alt="platform-logo" />
    <img
      v-if="service === 'kinopoisk'"
      src="@/assets/icons/icon-kinopoisk.svg"
      alt="platform-logo"
    />
    <img v-if="service === 'tj'" src="@/assets/icons/icon-tj.png" alt="platform-logo" />
    <img
      v-if="service === 'astra_lab'"
      src="@/assets/icons/icon-astra-lab.png"
      alt="platform-logo"
    />
    <img
      v-if="service === 'urbanads'"
      src="@/assets/icons/icon-urban-ads.png"
      alt="platform-logo"
    />
  </span>
</template>

<script>
export default {
  name: 'DepositIcons',
  props: {
    service: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.account-selector-name {
  display: flex;
  align-items: center;
  font-weight: 700;
  text-align: right;

  & > img {
    margin-right: 0.5rem;
    width: 2rem;
    height: 2rem;
    display: block;
  }
}
</style>
